import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIcon from '../../../elements/oe-icon';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEFNElement from '../../../elements/oe-flow-nav-elements';

export default class OEFNHelpHandling extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                general: '',
                features: '',
                navigation: {
                    title: '',
                    rotate: '',
                    move: '',
                    zoom: '',
                    reset: ''
                },
                view: {
                    title: '',
                    context: '',
                    hide: '',
                    separate: '',
                    transparent: '',
                    distinguish: ''
                },
                reset: '',
                tree: {
                    title: '',
                    expand: '',
                    name: '',
                    color: '',
                    visibility: ''
                },
                label: '',
                cut: {
                    title: '',
                    quickCut: '',
                    all: '',
                    touched: '',
                    touch: '',
                    bySwipe: '',
                    swipe: '',
                    doubleClick: '',
                    shift: '',
                    reset: ''
                },
                colorize: '',
                explosion: '',
                mediaCenter: '',
                info: '',
                settings:    {
                    title: '',
                    language: '',
                    backgroundColor: '',
                    mouseSensitivity: '',
                    quality: ''
                },
                progress: '',
                back: '',
                forth: ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(nextProps.locStringPrefix !== this.props.locStringPrefix)  {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage(props)   {
        props = props || this.props;
        let si = this.oe.sharedInterface;
        this.setState({strings: {
            general: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_general'),
            features: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_features'),
            navigation: {
                title: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_navigation_title'),
                rotate: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_navigation_rotate'),
                move: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_navigation_move'),
                zoom: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_navigation_zoom'),
                reset: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_navigation_reset')
            },
            view: {
                title: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_view_title'),
                context: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_view_context'),
                hide: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_view_hide'),
                separate: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_view_separate'),
                transparent: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_view_transparent'),
                distinguish: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_view_distinguish')
            },
            reset: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_reset'),
            tree: {
                title: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_tree_title'),
                expand: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_tree_expand'),
                name: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_tree_name'),
                color: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_tree_color'),
                visibility: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_tree_visibility')
            },
            label: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_label'),
            cut: {
                title: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_title'),
                quickCut: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_quick_cut'),
                all: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_all'),
                touched: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_touched'),
                touch: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_touch'),
                bySwipe: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_by_swipe'),
                swipe: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_swipe'),
                doubleClick: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_double_click'),
                shift: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_shift'),
                reset: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_cut_reset')
            },
            colorize: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_colorize'),
            explosion: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_explosion'),
            mediaCenter: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_media_center'),
            info: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_info'),
            settings:    {
                title: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_settings_title'),
                language: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_settings_language'),
                backgroundColor: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_settings_background_color'),
                mouseSensitivity: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_settings_mouse_sensitivity'),
                quality: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_settings_quality')
            },
            progress: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_progress'),
            back: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_back'),
            forth: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_handling_forth')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    render() {
        const helpViewIcons = OEIconCodes.helpView.helpHandling;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEFNElement.View>
                    <OEFNElement.Chapter
                        title={this.state.strings.general}
                    >
                        <OEFNElement.Paragraph
                            title={this.state.strings.navigation.title}
                        >
                            <OEFNElement.StdParagraphItem
                                iconCodeLeft={helpViewIcons.navigation.rotateTouch}
                                title={this.state.strings.navigation.rotate}
                                iconCodeRight={helpViewIcons.navigation.rotateMouse}
                            />
                            <OEFNElement.StdParagraphItem
                                iconCodeLeft={helpViewIcons.navigation.moveTouch}
                                title={this.state.strings.navigation.move}
                                iconCodeRight={helpViewIcons.navigation.moveMouse}
                            />
                            <OEFNElement.StdParagraphItem
                                iconCodeLeft={helpViewIcons.navigation.zoomTouch}
                                title={this.state.strings.navigation.zoom}
                                iconCodeRight={helpViewIcons.navigation.zoomMouse}
                            />
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.view.title}
                        >
                            <OEFNElement.StdParagraphItem
                                className="sub-paragraph"
                                iconCodeLeft={helpViewIcons.view.contextTouch}
                                title={this.state.strings.view.context}
                                iconCodeRight={helpViewIcons.view.contextMouse}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.contextMenuHide}
                                title={this.state.strings.view.hide}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.contextMenuHideOther}
                                title={this.state.strings.view.separate}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.contextMenuFade}
                                title={this.state.strings.view.transparent}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.contextMenuFadeOther}
                                title={this.state.strings.view.distinguish}
                            />

                        </OEFNElement.Paragraph>
                    </OEFNElement.Chapter>
                    <OEFNElement.Chapter
                        title={this.state.strings.features}
                    >
                        <OEFNElement.Paragraph
                            title={this.state.strings.reset}
                            iconCode={OEIconCodes.home}
                        >
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.tree.title}
                            iconCode={OEIconCodes.tree}
                        >
                            <OEFNElement.StdParagraphSubItem
                                title={this.state.strings.tree.expand}
                                iconElement={
                                    <div className="icon-element tree-expand">
                                        <OEIcon code={OEIconCodes.caretRight}/>
                                        {/*
                                        <OEIcon code={OEIconCodes.ctNode}/>
                                        */}
                                    </div>
                                }
                            />
                            <OEFNElement.StdParagraphSubItem
                                title={this.state.strings.tree.name}
                                iconElement={
                                    <div className="icon-element tree-name">
                                        vena
                                    </div>
                                }
                            />
                            {/*
                            <OEFNElement.StdParagraphSubItem
                                title={this.state.strings.tree.color}
                                iconElement={
                                    <div className="icon-element tree-color">
                                        <div></div>
                                    </div>
                                }
                            />
                            */}
                            <OEFNElement.StdParagraphSubItem
                                title={this.state.strings.tree.visibility}
                                iconElement={
                                    <div className="icon-element tree-rm">
                                        <button className="ct_btn ct_rm_btn" disabled={true}>
                                            <OEIcon className="button-visible" code={OEIconCodes.eye}/>
                                        </button>
                                    </div>
                                }
                            />

                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.label}
                            iconCode={OEIconCodes.label}
                        >
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.cut.title}
                            iconCode={OEIconCodes.cut}
                        >
                            {/*
                            <OEFNElement.StdParagraphSubItem
                                className="sub-paragraph"
                                iconCode={OEIconCodes.cutToolTouch}
                                title={this.state.strings.cut.quickCut}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.cutToolAll}
                                title={this.state.strings.cut.all}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.cutToolTouched}
                                title={this.state.strings.cut.touched}
                            />

                            <OEFNElement.Spacer />
                            */}

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                iconCodeLeft={helpViewIcons.cut.touchTouch}
                                title={this.state.strings.cut.touch}
                                iconCodeRight={helpViewIcons.cut.touchMouse}
                            />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                iconCodeLeft={helpViewIcons.cut.shiftTouch}
                                title={this.state.strings.cut.shift}
                                iconCodeRight={helpViewIcons.cut.shiftMouse}
                            />

                            <OEFNElement.StdParagraphSubItem
                                iconCode={OEIconCodes.reset}
                                title={this.state.strings.cut.reset}
                            />

                            {/*
                            <OEFNElement.Separator/>

                            <OEFNElement.StdParagraphSubItem
                                className="sub-paragraph"
                                iconCode={OEIconCodes.cutToolSwipe}
                                title={this.state.strings.cut.bySwipe}
                            />

                            <OEFNElement.Spacer />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                iconCodeLeft={helpViewIcons.cut.swipeTouch}
                                title={this.state.strings.cut.swipe}
                                iconCodeRight={helpViewIcons.cut.swipeMouse}
                            />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                iconCodeLeft={helpViewIcons.cut.doubleClickTouch}
                                title={this.state.strings.cut.doubleClick}
                                iconCodeRight={helpViewIcons.cut.doubleClickMouse}
                            />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                iconCodeLeft={helpViewIcons.cut.shiftTouch}
                                title={this.state.strings.cut.shift}
                                iconCodeRight={helpViewIcons.cut.shiftMouse}
                            />
                            */}

                        </OEFNElement.Paragraph>

                        {/*
                        <OEFNElement.Paragraph
                            title={this.state.strings.colorize}
                            iconCode={OEIconCodes.color}
                        >
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.explosion}
                            iconCode={OEIconCodes.explode}
                        >
                        </OEFNElement.Paragraph>
                        */}

                        <OEFNElement.Paragraph
                            title={this.state.strings.mediaCenter}
                            iconCode={OEIconCodes.mediaCenter}
                        >
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.info}
                            iconCode={OEIconCodes.info/*infoQuestionMark*/}
                        >
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.settings.title}
                            iconCode={OEIconCodes.settings}
                        >
                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                title={this.state.strings.settings.language}
                            />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                title={this.state.strings.settings.backgroundColor}
                            />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                title={this.state.strings.settings.mouseSensitivity}
                            />

                            <OEFNElement.StdParagraphItem
                                className="left-align"
                                title={this.state.strings.settings.quality}
                            />

                        </OEFNElement.Paragraph>

                    </OEFNElement.Chapter>

                    {/*
                    <OEFNElement.Chapter
                        title={this.state.strings.progress}
                    >
                        <OEFNElement.Paragraph
                            title={this.state.strings.back}
                            iconCode={OEIconCodes.stateBack}
                        >
                        </OEFNElement.Paragraph>

                        <OEFNElement.Paragraph
                            title={this.state.strings.forth}
                            iconCode={OEIconCodes.stateForth}
                        >
                        </OEFNElement.Paragraph>

                    </OEFNElement.Chapter>
                    */}

                    <OEFNElement.Spacer height="1em" /*16px*//>
                </OEFNElement.View>
            </React.Fragment>
        );
    }
}

OEFNHelpHandling.defaultProps = {
    moduleId:           '',
    locStringPrefix:    ''
};

OEFNHelpHandling.propTypes = {
    moduleId:           PropTypes.string,
    locStringPrefix:    PropTypes.string
};